export default __webpack_public_path__ + "static/media/earthquake.04284b63.svg";